import { Component, Input, Output, EventEmitter, OnInit, OnDestroy } from '@angular/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { SkuRankingHelper } from 'src/app/components/pages/sku-ranking/sku-ranking-helper';
import { FILTER_CONFIGS_HQ } from 'src/app/model/constants';
import { FiltersHelper } from './filters-helper';
import { FilterHelper } from '../add-more-filter/filter-helper';
import { UserService } from 'src/app/services/user.services';
import { HttpClient } from '@angular/common/http';
interface FilterOption {
  value: string;
  text: string;
}

interface FilterEvent {
  keyName: string;
  selectedItems: string[];
}

interface FilterRelationship {
  parent: string;
  child: string;
}

@Component({
  selector: 'app-add-more-filter-ranking',
  templateUrl: './filters.html',
  styleUrls: ['./filters.scss']
})
export class AddMoreFilterRankingComponent implements OnInit, OnDestroy {
  @Input() listData_Filter: any = {};
  @Input() lstOption_Selected: any = {};
  @Input() lstOption_States: any = {};
  @Input() lstOption_IsUsed: Record<string, boolean> = {};
  @Input() isShowAddMoreFilterSection: boolean = true;
  @Input() isShowAddMoreFilter: boolean = true;
  @Input() isAddMoreFilter: boolean = false;
  @Input() isAlwaysShowApplyBtn: boolean = false;
  @Output() onUpdateChart = new EventEmitter<{ lstOption_States: any, lstOption_Selected: any }>();
  @Output() onResetFiltersGroup = new EventEmitter<{ data: any }>();

  readonly filterModuleName: string = 'sku-ranking';
  readonly sectionName: string = 'vs-ly-sku-ranking';
  readonly CONFIGS = FILTER_CONFIGS_HQ?.ADD_MORE_FILTER?.SKU_RANKING || {
    COLLECTIONS1: [],
    COLLECTIONS2: [],
    COLLECTIONS3: [],
    COLLECTIONS4: []
  };

  lstOptions: Record<string, FilterOption[]> = {};
  isShowApplyBtn: boolean = false;
  isFirstLoad: boolean = true;
  isResetFilter: boolean = false;
  userGroupName: string = '';
  private destroy$ = new Subject<void>();
  private originalData: Record<string, any[]> = {};

  constructor(private filtersHelper: FiltersHelper, private userService: UserService, private http: HttpClient) { }

  ngOnInit(): void {
    this.isAddMoreFilter = false;
    this.isShowApplyBtn = false;
    Object.keys(this.lstOption_States).forEach(key => {
      if (this.lstOption_States[key] === 'tentative') {
        this.lstOption_States[key] = 'disable';
      }
    });
    this.lstOptions = this.listData_Filter?.lstOptions_IndexDB ? this.listData_Filter?.lstOptions_IndexDB : FilterHelper.getDefaultFilterList(this.CONFIGS);
    this.initAllOptionSelect();
    this.isShowAddMoreFilter = this.filtersHelper.getDefaultVisibleFilterList().length > 0;
    this.isShowAddMoreFilterSection = this.isShowAddMoreFilter;
    this.userGroupName = this.userService.getUserInfo() || '';

    console.log('this.lstOption_IsUsed', this.lstOption_IsUsed);
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  private initializeDefaultFilters(): void {
    const allCollections = [
      ...this.CONFIGS.COLLECTIONS1,
      ...this.CONFIGS.COLLECTIONS2,
      ...this.CONFIGS.COLLECTIONS3,
      ...this.CONFIGS.COLLECTIONS4
    ];

    allCollections.forEach(filterName => {
      this.lstOptions[filterName] = [{ value: 'All', text: 'All' }];

      if (!this.lstOption_Selected[filterName]) {
        this.lstOption_Selected[filterName] = ['All'];
      }
    });
  }

  private processApiResponse(response: any): void {
    if (!this.isValidApiResponse(response)) {
      return;
    }

    const { filters, data } = response;

    filters.forEach((filterName: string) => {
      const uniqueValues = this.filtersHelper.extractUniqueValues(data, filterName);
      this.lstOptions[filterName] = this.filtersHelper.createFilterOptions(uniqueValues);
      this.originalData[filterName] = data;
      const options = this.lstOptions[filterName] || [];
      const validIds = new Set(options.map(o => o["value"]));
      this.lstOption_Selected[filterName] = this.lstOption_Selected[filterName].filter(s => validIds.has(s));
    });

  }

  private isValidApiResponse(response: any): boolean {
    return response?.filters?.length > 0 &&
      response?.data?.length > 0 &&
      Array.isArray(response.filters) &&
      Array.isArray(response.data);
  }

  private subscribeToApiData(apiCall: any): void {
    apiCall.pipe(takeUntil(this.destroy$)).subscribe({
      next: (response: any) => {
        this.processApiResponse(response);
      },
      error: (error: any) => {
        console.error('Error fetching filter data:', error);
      }
    });
  }

  initAllOptionSelect(keyName?: string, isAddMoreFilter?: boolean): void {
    if (Object.keys(this.lstOptions).length === 0 || this.isFirstLoad) {
      this.initializeDefaultFilters();
      this.subscribeToAllApiCalls();
      this.isFirstLoad = false;
    } else {
      if (keyName) {
        this.initOptionSelect(keyName, ['All']);
        this.resetOptions(keyName);
      }
    }
  }

  private subscribeToAllApiCalls(): void {
    const apiCalls = [
      SkuRankingHelper.getLstAllOptionsBottlerEnData(),
      SkuRankingHelper.getLstAllOptionsBottlerSaleData(),
      SkuRankingHelper.getLstAllOptionsCategoryData(),
      SkuRankingHelper.getLstAllOptionsMarkerBrandData(),
      SkuRankingHelper.getLstAllOptionsPackageData()
    ];

    apiCalls.forEach(apiCall => this.subscribeToApiData(apiCall));
  }

  public onSaveItemsChange(event: FilterEvent): void {
    const { keyName, selectedItems } = event;
    this.lstOption_Selected[keyName] = selectedItems;
    SkuRankingHelper.getIntageskurankingAllfilter(this.http, this.lstOption_Selected);
    this.updateChart();
    //this.updateRelatedFilters(keyName, selectedItems);
  }

  private updateRelatedFilters(keyName: string, selectedItems: string[]): void {
    this.filtersHelper.updateRelatedFilters(keyName, selectedItems, this.originalData, this.lstOptions);
  }

  onResetFilter(): void {
    const { isResetFilter, isShowApplyBtn } = this.filtersHelper.resetFilter(
      this.lstOption_States,
      this.lstOption_Selected,
      this.isAddMoreFilter
    );

    this.isResetFilter = isResetFilter;
    this.isShowApplyBtn = isShowApplyBtn;

    Object.keys(this.lstOptions).forEach(key => {
      this.lstOptions[key] = [{ value: 'All', text: 'All' }];
    });

    this.originalData = {};
    this.isResetFilter = false;
    this.isFirstLoad = true;
    this.initAllOptionSelect('', this.isAddMoreFilter);
    this.updateChart();
  }

  onClose(): void {
    this.isAddMoreFilter = false;
    this.isShowApplyBtn = this.filtersHelper.isShowBtnApply(this.lstOption_States);
    this.isResetFilter = this.filtersHelper.isShowBtnResetFilter(this.lstOption_States, 4);
    this.filtersHelper.convertAllEnableTempToEnable(this.lstOption_States);
    this.filtersHelper.convertAllTentativeToDisable(this.lstOption_States);
    SkuRankingHelper.getIntageskurankingAllfilter(this.http, this.lstOption_Selected);
    this.updateChart();
    this.subscribeToAllApiCalls();
  }

  onAddMoreFilter(): void {
    this.isAddMoreFilter = true;
    this.isShowApplyBtn = true;
    this.filtersHelper.convertAllEnableToEnableTemp(this.lstOption_States);
    this.filtersHelper.convertAllDisabledToTentative(this.lstOption_States);
  }

  onConvertTentativeToEnableTemp(event: any): void {
    const { keyName, name: filterName } = event;

    if (keyName) {
      this.filtersHelper.convertTentativeToEnableTemp(this.lstOption_States, keyName);
    }
  }

  onConvertEnableTempToTentative(event: any) {
    const { keyName, name: filterName } = event;
    if (!FilterHelper.hasMultipleEnableTemp(this.lstOption_States)) {
      return;
    }
    const selectedArr = this.lstOption_Selected[keyName] || [];

    if (this.filtersHelper.isAllSelected(selectedArr)) {
      this.filtersHelper.convertEnableTempToTentative(this.lstOption_States, keyName);
    } else {
      const selectedArr = this.lstOption_Selected[keyName] || [];

      if (this.filtersHelper.isAllSelected(selectedArr)) {
        this.filtersHelper.convertEnableTempToTentative(this.lstOption_States, keyName);
      } else {
        let childFilters = this._getFiltersChildGroup(keyName);

        if (childFilters) {
          childFilters.unshift(keyName);
          this.onResetFiltersGroup.emit({ data: childFilters });
        }

        this.filtersHelper.convertEnableTempToTentative(this.lstOption_States, keyName);
        this.initOptionSelect(keyName, ['All']);
        this.resetOptions(keyName);
        this.isResetFilter = this.filtersHelper.isShowBtnResetFilter(this.lstOption_States, 4);
      }
    }
  }


  private _getFiltersChildGroup(keyName: string = '') {
    const relationships = this.filtersHelper.filterRelationships.filter(rel =>
      rel.parent === keyName || rel.grandparent === keyName
    );

    return relationships.map(rel => rel.child);
  }

  updateChart(): void {
    this.onUpdateChart.emit({
      lstOption_States: this.lstOption_States,
      lstOption_Selected: this.lstOption_Selected
    });

    FilterHelper.store_lstOption_States_Ranking(
      `${this.filterModuleName}_${this.userService.getUserFilterName()}`,
      this.lstOption_States,
      this.lstOption_Selected,
      this.lstOptions,
      this.userGroupName);
  }

  private initOptionSelect(keyName: string, selectedItems: string[]): void {
    this.lstOption_Selected[keyName] = selectedItems;
    this.initAllOptionSelect(keyName);
  }

  private resetOptions(keyName: string): void {
    this.lstOptions[keyName] = [{ value: 'All', text: 'All' }];
  }

  onMixpanelTracking(): void { }

  onMixpanelTrackingAddmorefilterClick(isOpen: boolean): void { }

  onMixpanelTrackingResetAddMoreFilter(): void { }
}
